'use strict';

import {  toNumber, get, set, isNil, indexOf, union } from 'lodash';
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import Worksheet from '../../../../common/components/Worksheet';
import ContactDetails from './Header/Details';
import SubNav from './SubNav';
import Events from  './Events';
import * as contactApi from '../../../../redux/actionCreators/async/contacts';
import * as contactStore from '../../../../redux/actionCreators/sync/contacts';
import TackIcon from '../../../../common/svgs/TackIcon';

import * as ui from '../../../../redux/actionCreators/sync/ui';
import { loadPins } from '../../../../redux/actionCreators/sync/';
import { updatePins } from '../../../../redux/actionCreators/async/employees';

const DEFAULT_DASHBOARD = '/admin/contacts';

function ContactWorksheet(props) {

  const contactId = parseInt(props.params.contactId) || 0;
  const prevPath = `${DEFAULT_DASHBOARD}`;
  const handleClose = (event) => props.dispatch(push(prevPath));
  const handleHideAction = () => props.refreshContact(props, replace, () => {
    props.dispatch(ui.hideSnackBar());
  });

  // pin functions
  const isPinned = () => {
    return indexOf(get(props.pinnedData, 'contacts', []), get(props, 'contact.profile.id')) >= 0;
  }

  const handleTogglePin = () => {
    return () => {
      let newPinnedData = props.pinnedData;
      if (isPinned()) {
        _.pull(newPinnedData.contacts, props.contact.profile.id)
      }
      else {
        set(newPinnedData, 'contacts', union(get(newPinnedData, 'contacts', []), [props.contact.profile.id]));
      }

      props.dispatch(updatePins(newPinnedData, (err, pins) => {
        if (!err) {
          props.dispatch(loadPins(pins))}
        }
      ));
    }
  }

  const pin = <div className='pin' onClick={handleTogglePin()}> <TackIcon /> <span className='pin-text'>{isPinned() ? 'unpin' : 'pin'}</span></div>;
  return (
    <div>
      {
       !isNil(props.contact) && !isNil(props.contact.user) && !isNil(props.contact.profile)
       &&
      <Worksheet
        baseRoute='/admin/contacts'
        dispatch={props.dispatch}
        location={props.location}
        pin={pin}
        >

        { /*[Not Required] Add profile card component ex:*/}
        { /* <JobRequestProfile key='Card' /> */}
        <div key='Card'>
          <ContactDetails contactId={contactId} />
        </div>

        { /*[Not Required] Add subnav component ex:*/}
        { /* <JobRequestSubNav key='SubNav' /> */}
        <div key='SubNav'>
          <SubNav  contactId={contactId} />
        </div>

        { /*[Not Required] Add Sidebar component ex:*/}
        { /* <JobRequestSide key='Side' /> */}
        <ul key='Side'>
          <Events contactId={contactId} />
        </ul>

        { /* Children components will be rendered in bottom panels area */ }
        {
          props.children
        }

      </Worksheet>

    }
    </div>
  );
}

export default connect((store, props) => {
    const contact = get(store.admin, 'contactInContactWorksheet', {});
    return {
      staticData: store.staticData,
      ui        : store.ui,
      pinnedData: get(store.pins, 'pinned', {}),
      contact
    };
  },
  (dispatch) => {
    return {
      dispatch,
      refreshContact: OnEnterRefreshContact({dispatch})
    };
  }
)(ContactWorksheet);

export function OnEnterRefreshContact(store) {
  return (nextState, replace, done) => {

    const id = toNumber(nextState.params.contactId);
    store.dispatch(contactStore.clearContactInContactWorksheet());
    store.dispatch(contactApi.getContact(id, (err, data) => {
      if (err || !data) {
        replace(DEFAULT_DASHBOARD);
        return done(err);
      }

      // We have to clear the store admin.contactInContactWorksheet before using it. Because the merge..
      store.dispatch(contactStore.updateContactInContactWorksheet(data));

      done();
    }));
  };
}



// WEBPACK FOOTER //
// ./shared/react/admin/Contact/Worksheet/index.js